var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    transform: "translate(0 0.00012207)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.00012H35L41.5 10.5001L48 17.0001V52.0001H8V4.00012Z",
    fill: "#F6DDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 4.00012L41.5 10.5001L48 17.0001H35V4.00012Z",
    fill: "#ECBCBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 42.0001C22.477 42.0001 18 37.5231 18 32.0001C18 26.4771 22.477 22.0001 28 22.0001C33.523 22.0001 38 26.4771 38 32.0001C38 37.5231 33.523 42.0001 28 42.0001ZM28 30.5861L25.172 27.7571L23.757 29.1721L26.586 32.0001L23.757 34.8281L25.172 36.2431L28 33.4141L30.828 36.2431L32.243 34.8281L29.414 32.0001L32.243 29.1721L30.828 27.7571L28 30.5861Z",
    fill: "#C02020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadFailedIcon);
export default __webpack_public_path__ + "static/media/fileUploadFailedIcon.ca7d17f186bd876b8eba464e52984d8b.svg";
export { ForwardRef as ReactComponent };